import React, { memo } from 'react';
import MDBadge from 'components/MDBadge';

// List of standard MUI colors that can be used with the color prop
const standardColors = ['primary', 'secondary', 'info', 'success', 'warning', 'error', 'light', 'dark'];

export function ProductionStatus({ status }) {
    if (!status) {
        return <MDBadge variant="gradient" color="secondary" size="sm" badgeContent="Durum Yok" />;
    }

    // Status artık doğrudan Tag objesi olduğu için
    // Check if the color is one of the standard MUI colors or a custom HEX/RGB
    const isStandardColor = status.color && standardColors.includes(status.color);

    // For custom colors, we'll use inline styles instead of the color prop
    if (!isStandardColor && status.color) {
        return (
            <MDBadge
                variant="gradient"
                size="sm"
                badgeContent={status.name || 'Durum Yok'}
                sx={{
                    backgroundColor: status.color,
                    color: '#ffffff',
                }}
            />
        );
    }

    // For standard colors, use the color prop
    return (
        <MDBadge
            variant="gradient"
            color={status.color || 'secondary'}
            size="sm"
            badgeContent={status.name || 'Durum Yok'}
        />
    );
}

export default memo(ProductionStatus);
